var _circle, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgArrowLeft = function SvgArrowLeft(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_18710",
    "data-name": "Group 18710",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#f2f2f2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-down-sign-to-navigate",
    transform: "translate(14.858 5.995) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_106648",
    "data-name": "Path 106648",
    d: "M6.112,6.968a.853.853,0,0,1-.605-.251L.251,1.461A.856.856,0,0,1,1.461.251L6.112,4.9,10.762.251a.856.856,0,0,1,1.21,1.211L6.717,6.717A.853.853,0,0,1,6.112,6.968Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgArrowLeft, _extends({
    svgRef: ref
  }, props));
});
export default "https://static.im-cdn.com/mjc/storefront/Compass/static/media/ArrowLeft.eb24bc9d.svg";
export { ForwardRef as ReactComponent };